import { Component, input } from '@angular/core';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'sanofi-no-items-disclaimer',
  standalone: true,
  imports: [
    I18nModule
  ],
  templateUrl: './no-items-disclaimer.component.html',
})
export class NoItemsDisclaimerComponent {
  readonly text = input.required();
  readonly itemsList = input.required<any[]>();
  readonly mix = input<string>('');
}
